import servlet from './servlet';

const combineSaga = {
  ...servlet,
};

export default combineSaga;
